"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isSourceInteractive = exports.getSamSourceIconPathFromSpec = exports.getSamSourceIconPath = exports.createUpdateDataFromSourceDef = exports.convertSourceDefToSourceDefCreator = exports.BetaSources = void 0;
var _globalStates = require("../../globalstates/globalStates");
var _routing = require("../../routing");
var _common = require("../common");
var _uuid = require("uuid");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var convertSourceDefToSourceDefCreator = exports.convertSourceDefToSourceDefCreator = function convertSourceDefToSourceDefCreator(data, duplicate) {
  var creator = _objectSpread({}, data);
  delete creator.auditData;
  return _objectSpread(_objectSpread({}, creator), {}, {
    id: duplicate ? {
      value: (0, _uuid.v4)()
    } : creator.id,
    assets: data.assets.map(function (a) {
      return _objectSpread(_objectSpread({}, a), {}, {
        sourceAssets: a.sourceAssets.map(function (s) {
          return s.id;
        })
      });
    })
  });
};
var rootPath = (0, _routing.getRootPath)();
var getSamSourceIconPath = exports.getSamSourceIconPath = function getSamSourceIconPath(source, defaultImage) {
  if (!source || (0, _globalStates.getGlobalStates)().isDevEnvironment) {
    return defaultImage || "./source.png";
  }
  var iconParam = source.params.find(function (param) {
    return param.name === "Icon";
  });
  if (!iconParam) {
    return defaultImage || "./source.png";
  }
  var filePath = iconParam.value.split("/");
  var fileName = filePath[filePath.length - 1];
  if ((0, _globalStates.isAWS)()) {
    "".concat(rootPath, "plugin/").concat(fileName);
  }
  var pluginDir = filePath[filePath.length - 3];
  return "".concat(rootPath, "html/icons/").concat(pluginDir, "/").concat(fileName);
};
var getSamSourceIconPathFromSpec = exports.getSamSourceIconPathFromSpec = function getSamSourceIconPathFromSpec(source, defaultImage) {
  if (!source || (0, _globalStates.getGlobalStates)().isDevEnvironment) {
    return defaultImage || "./source.png";
  }
  var iconParam = source.params.find(function (param) {
    return param.name === "Icon";
  });
  if (!iconParam || !iconParam.optionValues[0]) {
    return defaultImage || "./source.png";
  }
  var filePath = iconParam.optionValues[0].split("/");
  var fileName = filePath[filePath.length - 1];
  if ((0, _globalStates.isAWS)()) {
    "".concat(rootPath, "plugin/").concat(fileName);
  }
  var pluginDir = filePath[filePath.length - 3];
  return "".concat(rootPath, "html/icons/").concat(pluginDir, "/").concat(fileName);
};
var createUpdateDataFromSourceDef = exports.createUpdateDataFromSourceDef = function createUpdateDataFromSourceDef(source) {
  var assets = source.assets.map(function (item) {
    return {
      paramName: item.paramName,
      sourceAssets: item.sourceAssets.map(function (asset) {
        return {
          value: asset.value || asset.id.value
        };
      })
    };
  });
  return {
    id: source.id,
    name: source.name,
    description: source.description,
    orgData: source.orgData,
    type: source.type,
    params: source.params,
    displayResolution: source.displayResolution,
    outputType: source.outputType,
    controlMode: source.controlMode,
    assets: assets,
    scaling: source.scaling,
    userfulSecurityData: source.userfulSecurityData || (0, _common.EMPTY_USERFUL_SECURITY_DATA)(),
    sharingMode: source.sharingMode || "ALWAYS_SHARE_SOURCE",
    appInstanceID: source.appInstanceID || {
      value: (0, _uuid.v4)(),
      appID: {
        value: (0, _globalStates.getGlobalStates)().appID.value
      }
    },
    bufferCaptureData: source.bufferCaptureData,
    parentGroupID: source.parentGroupID
  };
};
var BetaSources = exports.BetaSources = ["Servicenow", "Grafana", "Domo"];
var isSourceInteractive = exports.isSourceInteractive = function isSourceInteractive(sourceType) {
  var isInteractive = sourceType === "Power_BI" || sourceType === "Program_Runner" || sourceType === "Remote_Desktop" || sourceType === "Web_Browser" || sourceType === "VNC_Viewer" || sourceType === "Web_Browser_YouTube" || sourceType === "Tableau" || sourceType === "Epic" || sourceType === "Playlist" || sourceType === "Servicenow" || sourceType === "Power_Point" || sourceType === "Grafana" || sourceType === "Emerald_Signage" || sourceType === "Domo" || sourceType === "Excel" || sourceType === "Clock" || sourceType === "WorldClock" || sourceType === "Weather" || sourceType === "SAP" || sourceType === "Timer" || sourceType === "Splunk" || sourceType === "Stopwatch";
  return isInteractive;
};